import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  LoadingController,
  ToastController,
  Platform,
  AlertController,
} from '@ionic/angular';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class CommonProvider implements OnInit {
  loader: any;
  toast: any;
  constructor(
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    private platform: Platform,   
    public alertController: AlertController,
    private router: Router
  ) {}
  ngOnInit() {}

  PostMethod(url, data, headers) {
    return new Promise(async (resolve, reject) => {
      await this.showLoader();
      return this.http.post(url, data, { headers }).subscribe((data) => {
        this.hideLoader();
        resolve(data);
      });
    });
  }

  GetMethod(url, data ,headers?) {
    return new Promise(async (resolve, reject) => {
      await this.showLoader();
      return this.http.get(url, { params: data,headers }).subscribe((data) => {
        this.hideLoader();
        resolve(data);
      });
    });
  }

  showLoader(myMsg = 'Loading.') {
    //this.loader.message = myMsg;
    return new Promise((resolve, reject) => {
      this.loadingCtrl
        .create({
          spinner: 'crescent',
          message: myMsg,
        })
        .then((Loader) => {
          this.loader = Loader;
          this.loader.present();
          resolve(true);
        });
    });
  }

  showToast(myMsg = "try again later.", myShowCloseBtn = false, myAutoCloseTime = 10000, color = 'dark') {
    this.toast = this.toastCtrl
        .create({
            message: myMsg,
            duration: myShowCloseBtn ? myAutoCloseTime : 3000,
            position: "top",
            color: color
        })
        .then((toastData) => {
            toastData.present();
        });
}

  async hideLoader() {
    await this.loader.dismiss();
  }

    private fooSubject = new Subject<any>();

    publishSomeData(data: any) {
        this.fooSubject.next(data);
    }

    getObservable(): Subject<any> {
        return this.fooSubject;
    }
}

